module.exports = __webpack_public_path__ + "static/media/555.ce61efe0.png";